import { Injectable } from "@angular/core";
import { Viewerlayer } from "../../model/viewerlayer";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { SaveViewerlayer } from "../../model/SaveViewerlayer";

@Injectable({
  providedIn: "root",
})
export abstract class LayerUtilsService {
  static enabled3D(layer: Viewerlayer) {
    if (layer && layer.sourceName === ViewerConstants.SOURCE_NAME.COLLECTION && layer.enableOblique) {
      const obliqueLayer = layer.childs.find((child) => child.sourceName === ViewerConstants.SOURCE_NAME.OBLIQUE);
      if (obliqueLayer) {
        return obliqueLayer.enabled;
      }
    }
    return false;
  }

  /**
   * Flattens a layer array so GROUPLAYER children are searchable alongside top-level layers,
   * regardless of nesting depth. Used by id/name lookups (e.g. the AI apply_layer_style and
   * get_layer_geometry tools) that must be agnostic to whether a layer sits at the top level
   * or is nested inside a group.
   */
  static flattenWithChildren(layers: Viewerlayer[]): Viewerlayer[] {
    return layers.flatMap((layer) => [
      layer,
      ...(layer.childs?.length ? LayerUtilsService.flattenWithChildren(layer.childs) : []),
    ]);
  }

  /**
   * We only get some data to reduce the size for the layers
   * We use to send to backend and also to create url parameters
   * @param layers
   */
  static reduceLayers(layers: Viewerlayer[], childs: boolean = false): SaveViewerlayer[] {
    const reducedLayers = layers?.map((layer) => {
      const aoiLayers = [];
      if (childs && layer.aois?.length) {
        const aois = layer.aois?.filter((aoi) => aoi.enabled) || [];

        aois.forEach((aoi) => {
          const childLayers = [];
          const aoiChildren = aoi.aois?.filter((child) => child.enabled) || [];
          aoiChildren.forEach((child) => {
            const auxAoi: SaveViewerlayer = {
              visible: child.visible,
              id: child.id,
              layer: child.layer || child.name,
            };
            childLayers.push(auxAoi);
          });
          const aoiLayer: SaveViewerlayer = {
            visible: aoi.visible,
            id: aoi.id,
            layer: aoi.layer || aoi.name,
            enabledAois: childLayers,
          };
          aoiLayers.push(aoiLayer);
        });
      }
      return {
        id: layer.id,
        layer: layer.layer || layer.name,
        visible: layer.visible,
        enabledAois: aoiLayers,
      } as SaveViewerlayer;
    });
    return reducedLayers;
  }

  /**
   * Update some configuration for array of layers, from other array of layers
   * @param layers
   * @param configLayers
   */
  static syncLayersConfiguration(layers: Viewerlayer[], configLayers: Viewerlayer[], map: any = null): Viewerlayer[] {
    layers.map((layer) => {
      const config = configLayers.find((urlLayer) => urlLayer.id === layer.id);
      if (config) {
        if (map && config?.visible !== layer.visible) {
          map.changeVisibility(layer.id, config.visible);
          layer.visible = config.visible;
        } else {
          layer.visible = config.visible ?? layer.visible;
        }
        // layer.order = config.order ?? layer.order;
        layer.enabled = config.enabled ?? layer.enabled;
        // layer.opacity = config.opacity ?? layer.opacity;
        // layer.style = config.style ?? layer.style;
        if (layer.aois?.length && config.enabledAois?.length) {
          LayerUtilsService.syncLayersConfiguration(layer.aois, config.enabledAois, map);
        }
      }
    });
    return layers;
  }
}
